import DpBillsPresenter from "@adapters/presenters/Reports/DpBills";
export default (useCases, actions) => {
    return {
        dpBillReport: new DpBillsPresenter(useCases, actions),
    };
};
